import Minilog from 'minilog';

import {addErrorMessage} from './feedback';
import {createMergeAction} from './base';
import {V2Resource, V2ListModel} from './services';
import * as Locale from './locale';

let logger = Minilog('frontend.models.gateways');

/**
 * Data of gateways in global state
 */
export interface GatewayState {
    map: Map<string, Object>;
}

/**
 * Format of gateway data as received from V2 API
 */
export interface V2Gateway {
    gateway_id: string;
    city: string;
    country_name: string;
    estimate: boolean;
    interval: any;
    ip: string;
    latitude: number;
    longitude: number;
    premises: any;
    region_name: string;
    resource_uri: string;
}

/**
 * Resource for gateway(s) user can access
 */
class GatewayResource extends V2Resource {
    constructor() {
        super(V2Resource.GATEWAY);
    }
}

/**
 * Global gateway API instance
 *
 * @type {GatewayResource}
 */
export var GatewayAPI: GatewayResource = new GatewayResource();

/**
 * Merge: set gateways in global store
 */
function setGateways(gateways: Array<V2Gateway>) {
    let gatewayMap = {};
    gateways.forEach(function(gateway) {
        gatewayMap[gateway.gateway_id] = gateway;
    });

    return createMergeAction(
        'gateways_set',
        {data: {gateways: {map: gatewayMap}}}
    );
}

/**
 * Merge: enable loading gateways
 */
function enableGatewayLoad() {
    return createMergeAction(
        'gateway_load',
        {ui: {gateways: {loading: true}}}
    );
}

/**
 * Merge: disable loading gateways
 */
function disableGatewayLoad() {
    return createMergeAction(
        'gateway_loaded',
        {ui: {gateways: {loading: false}}}
    );
}

/**
 * Thunk: retrieves the gateways for the current logged-in user
 * and stores it in global state.
 */
export function getGateways() : Function {
    return function (dispatch) {
        dispatch(enableGatewayLoad());
        return GatewayAPI.listAll<V2ListModel<V2Gateway>>().then(function(response) {
            dispatch(setGateways(response.data));
            dispatch(disableGatewayLoad());
        }).catch(function() {
            dispatch(addErrorMessage(Locale.TEXT_ERROR_GATEWAYS));
            dispatch(disableGatewayLoad());
        });
    };
}
